<template>
  <main ref="loadDetail">
    <header class="mb-6">
      <vx-card class="rounded-none">
        <div class="vx-row items-start" v-if="lembaga !== null">
          <div class="vx-col mb-8 md:mb-0 md:w-1/5 lg:w-1/5 xl:w-1/5 sm:w-full">
            <img
              key="lembaga"
              :src="
                lembaga.user.file
                  ? lembaga.user.file.includes('http')
                    ? lembaga.user.file
                    : `${url.baseFl}/${lembaga.user.file}`
                  : emptyImage
              "
              alt="lmbg-img"
              class="rounded-lg shadow-md cursor-pointer block w-full"
            />
          </div>
          <div class="vx-col mb-8 md:mb-0 w-full md:w-3/5 lg:w-3/5 xl:w-3/5 sm:w-full">
            <h4 class="mb-4">{{ lembaga.name }}</h4>
            <p class="mb-2">
              <strong>Total Pendapatan</strong>
            </p>
            <h5 class="mb-4">
              <strong class="text-success text-2xl">{{ total | toCurrency }}</strong>
            </h5>
          </div>
          <div class="vx-col mb-8 md:mb-0 w-full md:w-1/5 lg:w-1/5 xl:w-1/5 sm:w-full">
            <p class="mb-2">
              <strong>Filter Tanggal</strong>
            </p>
            <p class="mb-1">Dari</p>
            <flat-pickr
              class="w-full sidebar-input"
              :config="configFromdateTimePicker"
              v-model="dari_tgl"
              placeholder="Dari Tanggal"
              @on-change="onFromChange"
            />

            <p class="mb-1">Sampai</p>
            <flat-pickr
              :disabled="dari_tgl === null"
              class="w-full sidebar-input"
              :config="configTodateTimePicker"
              v-model="sampai_tgl"
              placeholder="Sampai Tanggal"
              @on-change="onToChange"
            />
          </div>
          <!-- <div class="vx-col w-full md:w-1/4 lg:w-1/5 xl:w-1/6">
            <div class="flex flex-col justify-center">
              <h1 class="text-success text-center mb-4">
                <strong>{{ donationPercent(lembaga) }}%</strong>
              </h1>
              <p class="text-center">Donasi Terkumpul</p>
            </div>
          </div> -->
        </div>
        <div v-else>
          <center class="py-6 w-full">
            <h4>Loading...</h4>
          </center>
        </div>
      </vx-card>
    </header>

    <!-- <section class="mb-6 flex justify-end">
      <vs-button
        :to="`/dashboard/lembaga/${lembaga.id}/edit`"
        class="rounded-none"
        size="small"
        color="primary"
        type="border"
        >Edit</vs-button
      >
    </section> -->

    <!-- Orang yang donasi -->
    <section v-if="lembaga !== null">
      <riwayat-pemasukan
        :mitra_id="lembaga.id"
        :akumulasiData="akumulasiData"
        :akumulasiDataNonLogin="akumulasiDataNonLogin"
      />
    </section>
  </main>
</template>
<script>
import emptyImage from "@/assets/images/elements/empty.png";
import RiwayatPemasukan from "./component/RiwayatPemasukan.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import url from "@/url";

export default {
  components: {
    RiwayatPemasukan,
    flatPickr,
  },
  watch: {
    dari_tgl() {
      if (this.dari_tgl === null) {
        this.sampai_tgl = null;
      }
    },
    dateBetween() {
      if (this.sampai_tgl !== null && this.dari_tgl !== null) {
        this.getDataForAkumulasi(this.lembaga);
        this.getDataForAkumulasiNonLogin(this.lembaga);
      }
    },
  },
  computed: {
    dateBetween() {
      return {
        dari: this.dari_tgl,
        sampai: this.sampai_tgl,
      };
    },
    total() {
      return this.pendapatanLogin + this.pendapatanNonLogin;
    },
    disabledDates() {
      return { to: new Date(this.dari_tgl) };
    },
    imageCampaign() {
      return this.lembaga.file !== null
        ? this.lembaga.file.includes("http")
          ? this.lembaga.file
          : `${this.url.baseFl}/${this.lembaga.file}`
        : this.emptyImage;
    },
    profile() {
      return this.$store.state.auth.profileAccess.profile;
    },
  },
  methods: {
    onFromChange(selectedDates, dateStr) {
      this.$set(this.configTodateTimePicker, "minDate", dateStr);
    },
    onToChange(selectedDates, dateStr) {
      this.$set(this.configFromdateTimePicker, "maxDate", dateStr);
    },
    getDataForAkumulasi(mitra) {
      this.transaksis = [];
      let byUser = {};
      let mitraId = {};
      let rangeTanggal = {};

      if (this.dari_tgl !== null && this.sampai_tgl !== null) {
        this.pendapatanLogin = 0;
        rangeTanggal = {
          date_between: `${this.dari_tgl},${this.sampai_tgl}`,
        };
      }

      if (mitra !== null) {
        mitraId = {
          mitra_id: mitra.id,
        };
      }

      if (this.profile.level.id !== 2) {
        if (this.mitra_id === null) {
          byUser = {
            user_id: this.profile.id,
          };
        }
      }
      this.$store
        .dispatch("transaksi/getTransaksi", {
          ...byUser,
          ...mitraId,
          ...rangeTanggal,
          status: 2,
        })
        .then((v) => {
          this.akumulasiData = v.data.filter(
            (d) =>
              d.jenis_pembayaran.name !== "PPOB" && d.jenis_pembayaran.name !== "TOP UP"
          );

          this.akumulasiData.forEach((v) => {
            this.pendapatanLogin += v.jumlah_bayar;
          });
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getDataForAkumulasiNonLogin(mitra) {
      this.transaksis = [];
      let byUser = {};
      let mitraId = {};
      let rangeTanggal = {};

      if (this.dari_tgl !== null && this.sampai_tgl !== null) {
        this.pendapatanNonLogin = 0;
        rangeTanggal = {
          date_between: `${this.dari_tgl},${this.sampai_tgl}`,
        };
      }

      if (mitra !== null) {
        mitraId = {
          mitra_id: mitra.id,
        };
      }

      if (this.profile.level.id !== 2) {
        if (this.mitra_id === null) {
          byUser = {
            user_id: this.profile.id,
          };
        }
      }
      this.$store
        .dispatch("transaksi/getTransaksiNonLogin", {
          ...byUser,
          ...mitraId,
          ...rangeTanggal,
          status: 2,
        })
        .then((v) => {
          this.akumulasiDataNonLogin = v.data.filter(
            (d) =>
              d.jenis_pembayaran.name !== "PPOB" && d.jenis_pembayaran.name !== "TOP UP"
          );

          this.akumulasiDataNonLogin.forEach((v) => {
            this.pendapatanNonLogin += v.jumlah_bayar;
          });
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getDataDetail(id) {
      this.$vs.loading({
        container: this.$refs.loadDetail,
        color: "primary",
      });
      this.$store
        .dispatch("lembaga/getDetailLembaga", id)
        .then((v) => {
          this.$vs.loading.close(this.$refs.loadDetail);
          this.lembaga = v;
          this.getDataForAkumulasi(this.lembaga);
          this.getDataForAkumulasiNonLogin(this.lembaga);
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadDetail);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    donationPercent(lembaga) {
      if (!lembaga.donasi_terkumpul) {
        lembaga.donasi_terkumpul = 0;
      }

      return Math.ceil(
        (parseInt(lembaga.donasi_terkumpul) / parseInt(lembaga.donasi)) * 100
      );
    },
  },
  data: () => ({
    url,
    emptyImage,
    lembaga: null,
    akumulasiData: [],
    akumulasiDataNonLogin: [],
    pendapatanNonLogin: 0,
    pendapatanLogin: 0,
    pendapatanTotal: 0,
    dari_tgl: null,
    sampai_tgl: null,
    configFromdateTimePicker: {
      minDate: null,
      maxDate: new Date("2100-12-30"),
      enableSeconds: false,
      enableTime: false,
      time_24hr: true,
      dateFormat: "Y-m-d",
    },
    configTodateTimePicker: {
      minDate: null,
      maxDate: new Date("2100-12-30"),
      enableSeconds: false,
      enableTime: false,
      time_24hr: true,
      dateFormat: "Y-m-d",
    },
  }),
  mounted() {
    this.getDataDetail(this.$route.params.id);
  },
  created() {
    this.$vs.loading.close();
  },
};
</script>

<style lang="scss" scoped>
img {
  max-height: 240px;
  overflow: auto;
  object-fit: cover;
}
</style>
